import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './baseQuery';
import { setProductDetails, setValidCustomForm, setError } from '@headless-shell/store';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: axiosBaseQuery(), // invoke factory
  tagTypes: ['Product'],
  endpoints: (builder) => ({
    addons: builder.query({
      query: () => ({ url: '/addons', method: 'GET' })
    }),
    getProductDetails: builder.query({
      query: ({ appId }) => ({
        //   url: `/api/v2/products/${appId}`,
        url: `api/product?appId=${appId}`,
        method: 'GET'
      }),
      transformResponse: (response) => {
        const { _embedded: { associatedAddons } = {}, customAttributes = [], pricing: { editions } = {}, integrationConfiguration, tags = [], resources = [], screenshots = [] } = response || {};
        const { forms = [], validationUrl } = integrationConfiguration?.productSettings || {};
        const hasAddons = associatedAddons?.length > 0 || false;
        const hasCustomForms = forms?.length > 0 || false;
        const customAttributeCheck = customAttributes?.some(c => c.label === 'Request a quote' && c?.valueKeys?.find(val => val === 'true'));
        const isConnector = tags?.find(tag => tag.name === 'TOP INTEGRATED APPS')?.children?.some(child => child.name === 'Data Connector');
        const showCarousel = resources.length > 0 || screenshots.length > 0;
        let requestQuoteFlag = false;
        editions?.map((ed, index) => {
          editions[index].showRequestQuoteButton = customAttributeCheck && ed.leadGen;
          if (ed.showRequestQuoteButton) {
            requestQuoteFlag = true;
          }
          return ed;
        });
        const carObj = customAttributes.find(attr => attr.attributeKey === 'consumerApplicationId');
        const carAppId = carObj ? carObj.value : null;
        return { ...response, hasAddons, hasCustomForms, isValidCustomForm: !validationUrl, requestQuoteFlag, carAppId, isConnector, showCarousel } || [];
      },
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setProductDetails(data));
          dispatch(setValidCustomForm(Boolean(data?.isValidCustomForm)));
        } catch (err) {
          // optional: dispatch(setValidCustomForm(false))
          dispatch(setError(err));
        }
      },
      providesTags: (result, error, { appId }) => [{ type: 'Product', id: appId }],
      transformErrorResponse: (response) => {
        console.error('Failed to fetch product details', response?.data || 'API Error');
        return [];
      }
    }),
    getConsentTexts: builder.query({
      query: ({ carId }) => ({
        url: `/api/consent/${carId}`,
        method: 'GET'
      }),
      transformResponse: (response) => {
        const consentTexts = response?.consumerApplications?.[0]?.applicationConsentTexts;
        console.log('response', consentTexts);
        return { consentTexts };
      },
      providesTags: (result, error, { carId }) => [{ type: 'Consent', id: carId }],
      transformErrorResponse: (response) => {
        console.error('Failed to fetch consent texts', response?.data || 'API Error');
        return [];
      }
    }),
    saveConsent: builder.mutation({
      query: ({ carId }) => ({
        url: `/api/consent/${carId}`,
        method: 'POST',
        allowConsent: true
      }),
      transformResponse: (response) => {
        return { success: true };
      },
      providesTags: (result, error, { carId }) => [{ type: 'Consent', id: carId }],
      transformErrorResponse: (response) => {
        console.error('Failed to save consent', response?.data || 'API Error');
        return [];
      }
    }),
    getAddonProducts: builder.query({
      query: ({ associatedAddons }) => {
        const queryString = new URLSearchParams();
        queryString.set('sor', 'mkpl');
        const addonProductIds = associatedAddons.map(addon => addon.addonId);
        queryString.set('ids', JSON.stringify(addonProductIds));
        return {
          url: `/api/product/listingbyids?${queryString}`,
          method: 'GET'
        };
      },
      transformResponse: (response) => {
        return response;
      },
      transformErrorResponse: (response) => {
        console.error('Failed to load addons', response?.data || 'API Error');
        return null;
      }
    })

  })
});

export const { useLoginMutation, useGetProductDetailsQuery, useLazyGetConsentTextsQuery, useSaveConsentMutation, useGetAddonProductsQuery, useLazyGetAddonProductsQuery } = productApi;
